import { NgModule }                  from '@angular/core';
import { Routes, RouterModule }         from '@angular/router';
import { IframeDocumentationComponent } from './iframe-documentation.component';


const routes: Routes = [
  {
    path: '', component: IframeDocumentationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IframeDocumentationRoutingModule { }
